import moment from 'moment'
import { dateFormat } from 'alto-utils/lib/utils'
import GroupMenu from './group_menu'

export default class MenuSummary
  constructor: (@menu) ->

  @for: (menu) ->
    # remove course menus without selection and group menus after deadline
    # also remove all parent menus for which the filtered child menus are empty
    canteenMenus = menu._canteenMenus
      .map (dailyMenus, canteenID) ->
        dailyMenus
          .map (groupMenus, formattedDate) ->
            groupMenus
              .map    (courseMenus) -> courseMenus.filter (courseMenu) -> courseMenu.hasSelection()
              .filter (courseMenus, groupName) ->
                canteen   = menu.canteens.find(canteenID)
                date      = moment(formattedDate, dateFormat)
                group     = menu.groups.find(groupName)
                groupMenu = new GroupMenu(canteen, date, group, courseMenus, menu)

                courseMenus.size and not groupMenu.isAfterDeadline()
          .filter (groupMenus) -> groupMenus.size
      .filter (dailyMenus) -> dailyMenus.size

    new @(menu.with(canteenMenus))

  canteenMenus: ->
    @menu.canteenMenus()
